import { getAssetPath } from "../utils/assets"

export const iconPaths = {
  downIcon: getAssetPath("icn-down"),
  reorderDots: getAssetPath("reorder-dots"),
  upIcon: getAssetPath("icn-up"),
}